<template>
  <div>
    <stop-show v-if="!showVIPSections" />
    <div v-else>
      <!-- banner 部分 -->
      <div class="wemember-banner">
        <div class="container">
          <div class="wemember-banner-wrap">
            <p class="wemember-title">TGO 鲲鹏会全球学员名单</p>
            <p class="wemember-slogan">构建全球化的有技术背景的优秀人才同侪学习成长平台</p>
          </div>
        </div>
      </div>

      <!-- 主体部分 -->
      <div class="wemember-panenl container" ref="panenl">

        <!-- 搜索部分 -->
        <search-bar :isMobile="isMobile" :barFixed="barFixed" @onInputWordsChange="debounceGetData" @getData="getData"></search-bar>
        <!-- 结果部分 -->
        <div  class="search-results">

          <!-- 结果列表 -->
          <search-results :data="results.list"></search-results>

          <!-- 分页器 -->
          <div class="search-pager" v-if="results.list.length">
            <iview-pager
            :current="pageInfo.page"
            :total="Number(results.page.total)"
            show-sizer
            show-total
            @on-change="setPage"
            @on-page-size-change="setSize"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from './Search.Bar'
// import SearchBarM from './Search.Bar-m'
import SearchResults from './Search.Results'
import IviewPager from '@/components/form/iview/components/page'
import StopShow from '@/components/stopShow'
import service from '@/service'

import lodash from 'lodash'
import { mapGetters, mapState } from 'vuex'

let DefaultPageInfo = {
  page: 1, // 当前页 1
  size: 10 // 默认 每页 10个
}

export default {
  data () {
    return {
      params: {}, // 发送给后端的参数
      pageInfo: Object.assign({}, DefaultPageInfo),
      results: {
        list: [],
        page: { total: 0, pages: 0 }
      },
      barFixed: false,
      debounceGetData: null
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    }),

    ...mapGetters([
      'showVIPSections'
    ])
  },
  components: {
    SearchBar,
    // SearchBarM,
    SearchResults,
    IviewPager,
    StopShow
  },
  created () {
    // window.addEventListener('scroll', this.listenerScroll)
    this.debounceGetData = lodash.debounce(this.getData, 500)
    if (!this.$route.query.uid) this.debounceGetData()
  },
  methods: {
    /**
     * 组合参数获取数据
     */
    getData (params) {
      this.params = params

      // 初始化每页的 page
      let { page } = DefaultPageInfo
      // 同步视图
      this.pageInfo.page = page
      let data = { ...this.params, page, size: this.pageInfo.size }
      console.log('Data', data)

      this.getConditionMemberInfo(data)
    },
    /**
     * 设置当前页码
     * 不改变用户设置的 size
     */
    setPage (page) {
      this.pageInfo.page = page

      let params = { ...this.params, page, size: this.pageInfo.size }
      this.getConditionMemberInfo(params)
    },
    /**
     * 设置每页的 size
     */
    setSize (size) {
      this.pageInfo.size = size
      if (this.pageInfo.page === 1) {
        let params = { ...this.params, page: this.pageInfo.page, size }
        this.getConditionMemberInfo(params)
      }
    },
    getConditionMemberInfo (params) {
      service.getConditionMemberInfo(params)
        .then(data => { this.results = data })
        .catch(err => console.log(err))
    },
    listenerScroll () {
      const panenl = this.$refs.panenl
      this.barFixed = panenl && panenl.getBoundingClientRect().top <= 0
    }
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.listenerScroll)
  }
}
</script>
<style scoped lang='scss'>
@import '../../style/bulma/app.sass';

// .foldAnimation-leave-active, .foldAnimation-enter-active {
//   transition: all 0.5s, ease;
// }

// .foldAnimation-leave-active, .foldAnimation-enter {
//   height: 0;
// }

// .foldAnimation-leave, .foldAnimation-enter-active {
//   height: 500px;
// }

.search-wrapper {
  position: sticky;
  top: 0;
  width: 92vw;
  margin: 4vw auto 2vw;
  background: #fff;

  .search-input {
    border: 1px solid rgba(233,233,233,1);
    border-radius: 3px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    font-size: 14px;

    .iconfont {
      font-size: 15px;
      color: #4a4a4a;
      margin-right: 10px;
    }

    .input-tag {
      flex-grow: 1;
      &::-webkit-input-placeholder {
        font-size: 13px;
        color: #9A9A9A;
      }
      &::-moz-placeholder {/* Firefox 18- */
        font-size: 13px;
        color: #9A9A9A;
      }
      &::-moz-placeholder{/* Firefox 19+ */
        font-size: 13px;
        color: #9A9A9A;
      }
      &::-ms-input-placeholder {
        font-size: 13px;
        color: #9A9A9A;
      }
    }

  }

}

.wemember-banner {
  height: 270px;
  background: url('./assets/banner-m.png') no-repeat center / cover;
  @include mobile {
    width: 100vw;
    height: 43vw;
  }
  .container {
    position: relative;
    height: 100%;
    .wemember-banner-wrap {
      max-width: 80vw;
      position: absolute;
      top: 50%;
      transform: translateY((-50%));
      .wemember-logo {
        width: 308px;
        margin-bottom: 10px;
      }
      .wemember-title {
        font-size: 46px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #fff;
        @include mobile {
          font-size: 6vw;
        }
      }
      .wemember-slogan {
        font-size: 23px;
        color: #fff;
        @include mobile {
          font-size: 4vw;
        }
      }
    }
  }
}

.wemember-panenl {
  margin: 0px auto 80px;
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  @include mobile {
    display: block;
    padding-top: 0;
  }
}

// 结果部分
.search-results {
  width: 712px;
  @include mobile {
    width: 92vw;
  }
}
.search-pager {
  display: flex;
  justify-content: center;
  margin-top: 50px;

  @include mobile {
    ::v-deep .ivu-page-total {
      font-size: 3vw;
      display: none;
    }
    ::v-deep .ivu-page-prev,
    ::v-deep .ivu-page-next {
      min-width: 6vw;
      height: 6vw;
      line-height: 6vw;
      font-size: 3vw;
    }
    ::v-deep .ivu-page-item,
    ::v-deep .ivu-page-item-jump-next,
    ::v-deep .ivu-page-item-jump-prev {
      min-width: 6vw;
      height: 6vw;
      line-height: 6vw;
      font-size: 3vw;
    }
    ::v-deep .ivu-page-options {
      margin-left: 12px;
      .ivu-page-options-sizer {
        margin: 0;
        .ivu-select {
          font-size: 3vw;
          .ivu-select-selection {
            height: 6vw;
            .ivu-select-selected-value {
              height: 6vw;
              line-height: 6vw;
            }
          }
        }
      }
    }
  }
}
</style>
